export function parseRecentProductIds(value, currentProductId = 0, maximum = 10) {
	const current = Number.parseInt(currentProductId, 10) || 0;
	const limit = Math.max(1, Number.parseInt(maximum, 10) || 10);
	const seen = new Set();
	const ids = [];

	for (const candidate of String(value || "").split(",")) {
		const id = Number.parseInt(candidate.trim(), 10);
		if (!Number.isSafeInteger(id) || id <= 0 || id === current || seen.has(id)) continue;
		seen.add(id);
		ids.push(String(id));
		if (ids.length >= limit) break;
	}

	return ids;
}

export function recommendationRequest(config, clientId = "") {
	const request = {
		recommendation_type: config.recommendation_type,
		recommender_client_identifier: config.recommender_client_identifier,
		size: config.size,
		hit_fields: config.hit_fields,
	};
	const normalizedClientId = String(clientId || "").trim();
	if (normalizedClientId) request.user_id = normalizedClientId;

	const itemIds = Array.isArray(config.item_ids)
		? [...new Set(config.item_ids.map((value) => String(value || "").trim()).filter(Boolean))]
		: [];
	if (itemIds.length) request.item_ids = itemIds;

	const blacklisted = Array.isArray(config.blacklisted_item_ids)
		? [...new Set(config.blacklisted_item_ids.map((value) => String(value || "").trim()).filter(Boolean))]
		: [];
	if (blacklisted.length) request.blacklisted_item_ids = blacklisted;

	return request;
}

export function hasMinimumRecommendations(products, minimumItems = 1) {
	const minimum = Math.max(1, Number.parseInt(minimumItems, 10) || 1);
	return Array.isArray(products) && products.length >= minimum;
}
